import {connect} from 'react-redux';

import {HandlerOf, PredicateOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {CellsConversationsDragItem} from '../../../../helpers/conversationCellHelpers';
import {
  canMoveToTagAction,
  moveToTagAction,
} from '../../../../store/data/conversations/tagConversationsActions';
import {TeammateWorkspaceStarItem} from './teammateWorkspaceStarItem';

/*
 * Props.
 */

interface TeammateWorkspaceStarItemContainerProps {
  starredTagId: number;
  namespace: string;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  canMoveToTagAction,
  moveToTagAction,
}));

export const TeammateWorkspaceStarItemContainer = connect(
  null,
  mapDispatchToProps,
  (_stateProps, dispatchProps, ownProps: TeammateWorkspaceStarItemContainerProps) => {
    const {starredTagId, namespace} = ownProps;

    const canConversationsDrop: PredicateOf<CellsConversationsDragItem> = (options) =>
      dispatchProps.canMoveToTagAction(options, starredTagId, namespace);

    const onConversationsDrop: HandlerOf<CellsConversationsDragItem> = (options) =>
      dispatchProps.moveToTagAction(options, starredTagId);

    return {
      ...ownProps,
      canConversationsDrop,
      onConversationsDrop,
    };
  },
)(TeammateWorkspaceStarItem);
